import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import AxiosInstance from "../../components/Axios";
import {MRT_ColumnFiltersState, MRT_PaginationState, MRT_SortingState} from "material-react-table";
import {
    mapJsonToRicProg,
    mapRicProgToJson,
    MonitorProgettiNodiApiResponse,
    MonitorProgettiRiepilogoApiResponse, RicProg
} from "./types";
import {EmailForm} from "../reports/types";
import AxiosInstanceUpload from "../../components/AxiosUpload";
import * as Yup from "yup";
import {Buffer} from "buffer";
import {format} from "date-fns";
import {sortingParam, columnFiltersParamWithDateRange} from "../../common/Services";
import {mapJsonToUserProg, mapUserProgToJson, UserProg} from "./types";
import {mapJsonToVersOre, mapJsonToVersOreDTOApiResponse, VersOre, VersOreDTO} from "../gestversore/types";
import {ProcedureResponse} from "./types";
import {DipProg, mapDipProgToJson, mapJsonToDipProg} from "../gestdipprog/types";

const moment = require('moment')

export function useGetAllMonitorProgettiRiepilogo(
    pagination: MRT_PaginationState,
    columnFilters: MRT_ColumnFiltersState,
    globalFilter: string,
    sorting: MRT_SortingState,
 ) {
    return useQuery<MonitorProgettiRiepilogoApiResponse>({
        queryKey: [
            'fetchMonitorProgettiRiepilogo',
            columnFilters, // refetch when columnFilters changes
            globalFilter,  // refetch when globalFilter changes
            pagination.pageIndex, // refetch when pagination.pageIndex changes
            pagination.pageSize, // refetch when pagination.pageSize changes
            sorting, // refetch when sorting changes
        ],
        queryFn: async () => {

            const keyazienda = localStorage.getItem('keyidazienda') || '';
            const keycoddip = localStorage.getItem('coddip') || 'NN';
            const keyrole = localStorage.getItem('keyrole') || '';

            const isAdmin =  keyrole.includes('TimeReportAdmin') ||  keycoddip.includes('DS') ;


            const myOffset =
                pagination.pageIndex === 0
                    ? '0'
                    : `${pagination.pageSize * pagination.pageIndex}`;

            let myURL = `?limit=${pagination.pageSize}&offset=${myOffset}&search=${globalFilter ?? ''}${columnFiltersParamWithDateRange(
                columnFilters,
                ''
            )}&ordering=${sortingParam(sorting, '')}`;

            // if (isAdmin)
            // myURL += `&CODDITTA=${keyazienda}`
            // else
            // myURL += `&CODDITTA=${keyazienda}` + `&REF=${keycoddip}`;

            myURL += `&CODDITTA=${keyazienda}`

            const response = await AxiosInstance.get(`monitorprogettiriepilogo/${myURL}`);

            return response.data;
        },
        refetchOnWindowFocus: false,
    });
}

export function useGetAllMonitorProgettiNodi(
    pagination: MRT_PaginationState,
    columnFilters: MRT_ColumnFiltersState,
    globalFilter: string,
    sorting: MRT_SortingState,
 ) {
    return useQuery<MonitorProgettiNodiApiResponse>({
        queryKey: [
            'fetchMonitorProgettiNodi',
            columnFilters, // refetch when columnFilters changes
            globalFilter,  // refetch when globalFilter changes
            pagination.pageIndex, // refetch when pagination.pageIndex changes
            pagination.pageSize, // refetch when pagination.pageSize changes
            sorting, // refetch when sorting changes
        ],
        queryFn: async () => {

            // const isadmin = localStorage.getItem(IS_ADMIN_KEY) === 'true'; // Ensures isadmin is treated as a boolean
            let codclifor = localStorage.getItem('keycodclifor') || '';

            const role = localStorage.getItem('keyrole') || '';

            const idazienda = localStorage.getItem('keyidazienda') || '';

            // console.log('codclifor: ',codclifor);


            const myOffset =
                pagination.pageIndex === 0
                    ? '0'
                    : `${pagination.pageSize * pagination.pageIndex}`;



            let myURL = `?limit=${pagination.pageSize}&offset=${myOffset}&search=${globalFilter ?? ''}${columnFiltersParamWithDateRange(
                columnFilters,
                ''
            )}&ordering=${sortingParam(sorting, '')}`;


            myURL += `&CODDITTA=${idazienda}`;

            const response = await AxiosInstance.get(`monitorprogettinodi/${myURL}`);

             // Fetch the data using the constructed URL
            // const response = await AxiosInstance.get(
            //     `monitorprogetti/${myURL}&VBT51_CODCLI=${codclifor}&VBT51_DITTA=${idazienda}&VBT51_FLGVAL=Y`
            //
            // );

            return response.data;
        },
        refetchOnWindowFocus: false,
    });
}


export function useGetUserProg(username: string) {
    return useQuery<UserProg[]>({
        queryKey: ['fetchUserProg', username],
        queryFn: async () => {
            const response = await AxiosInstance.get(`userprog/?BT26_USERNAME=${username}`);

         const results = response.data.results;


            return Array.isArray(results)
                ? results.map(mapJsonToUserProg)
                : [];
        },
        refetchOnWindowFocus: false,
    });
}





export function useCreateUserProg() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (userprogetti: UserProg) => {

      const response = await AxiosInstance.post('userprog/0/', mapUserProgToJson(userprogetti));
      return mapJsonToUserProg(response.data);
    },
    onSuccess: () => {
       queryClient.invalidateQueries({ queryKey: ['fetchUserProg'] });
    },
  });
}


export function useDeleteUserProg() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id }: { id: number }) => {
      if (!id) throw new Error('ID is required to delete');
      const response = await AxiosInstance.delete(`userprog/${id}/`);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['fetchUserProg'] });
    },
  });
}

export function useDeleteUserProgByUserCodProg() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      username,
      codprog,
    }: {
      username: string;
      codprog: string;
    }) => {
      if (!username || !codprog) {
        throw new Error('Username and codprog are required');
      }

      // Call Django backend to delete using both keys
      const response = await AxiosInstance.delete(
        `userprogdeletebyusercodprog/?BT26_USERNAME=${username}&BT26_CODPROG=${codprog}`
      );

      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['fetchUserProg'] });
    },
  });
}


export function useGetVersOreByProgNodo(codprog: string, codnodo: string) {
  return useQuery<{ results: VersOreDTO[]; count: number }>({
    queryKey: ['fetchVersOreByProgNodo', codprog, codnodo],
    queryFn: async () => {
  const response = await AxiosInstance.get(
    `versoredto/?limit=1000&offset=0&VBT00_CODPROG=${codprog}&VBT00_CODNODO=${codnodo}`
  );

            return mapJsonToVersOreDTOApiResponse(response.data);
        },
        refetchOnWindowFocus: false,
    });
}



export function useSpprCreateDatiProgNodi() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const response = await AxiosInstance.get('spprcreatedatiprognodi/');
      return response.data;
    },
    onSuccess: () => {
      // Optional: invalidate any related data
      queryClient.invalidateQueries({ queryKey: ['fetchMonitorProgettiRiepilogo'] });
    },
  });
}


export function useGetRicProgByProg(codprog: string, ditta: number) {
  return useQuery<RicProg>({
    queryKey: ['fetchRicProgByProg', codprog,ditta],
    queryFn: async () => {

      const response = await AxiosInstance.get('ricprog/');
      const transformedData = mapJsonToRicProg(response.data.data.RicProg);

      return transformedData;
    },
    refetchOnWindowFocus: false,
  });
}




export function useUpdateRicProg() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (ricprog: RicProg) => {
      const response = await AxiosInstance.patch(`ricprog/${ricprog.codprog}/`, mapRicProgToJson(ricprog));
      return response.data;
    },
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: ['fetchMonitorProgettiRiepilogo'] });
    },
  });
}

export function useCreateRicProg() {
  const queryClient = useQueryClient();
  return useMutation({

    mutationFn: async (ricprog: RicProg) => {

       const response = await AxiosInstance.post('ricprog/0/', mapRicProgToJson(ricprog));
       return response.data;
    },

     onSuccess: async (data, variables) => {

       queryClient.invalidateQueries({ queryKey: ['fetchMonitorProgettiRiepilogo'] });

   }, //refetch VersoOre after mutation, disabled for demo
     });
}

// export function useUpsertRicProg() {
//   const queryClient = useQueryClient();
//
//   return useMutation({
//     mutationFn: async (ricprog: RicProg) => {
//       try {
//         // Try to update (PATCH)
//         const response = await AxiosInstance.patch(
//           `ricprog/${ricprog.codprog}/`,
//           mapRicProgToJson(ricprog)
//         );
//         return response.data;
//       } catch (error: any) {
//         if (error.response && error.response.status === 404) {
//           // If not found, try to create
//           const response = await AxiosInstance.post(
//             `ricprog/${ricprog.codprog}/`,  // Upsert endpoint expects pk in path
//             mapRicProgToJson(ricprog)
//           );
//           return response.data;
//         }
//         throw error; // propagate other errors
//       }
//     },
//     onSuccess: () => {
//       queryClient.invalidateQueries({ queryKey: ['fetchMonitorProgettiRiepilogo'] });
//     },
//   });
// }

export function useUpsertRicProg() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (ricprog: RicProg) => {
      const response = await AxiosInstance.post(
        `ricprog/${ricprog.codprog}/`,
        mapRicProgToJson(ricprog)
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['fetchMonitorProgettiRiepilogo'] });
    },
  });
}



export function useSendEmail() {
  return useMutation({
    mutationFn: async (emailForm: EmailForm) => {
      return AxiosInstance.post('sendemail/', emailForm);
    },
  });
}

export function useUploadReport() {
  return useMutation({
    mutationFn: async (formData: FormData) => {
      return AxiosInstanceUpload.post('uploadreport/', formData);
    },
  });
}



export const validationSchema = Yup.object().shape({
                      fromDate: Yup.date().required('Selezione Data Inizio'),
                      toDate: Yup.date().test('is-after-or-equal', 'La data di fine deve essere successiva alla data di inizio', function (value) {
                                         const { fromDate } = this.parent; // Access fromDate from parent object
                                         if (!fromDate || !value) {
                                         return true; // Skip validation if fromDate or toDate is not set
                                      }
                                      return fromDate <= value; // Validate if toDate is after or equal to fromDate
                                    }),
                      emailTo: Yup.string().email('Email non è valida'),
                      idcli:  Yup.string().required('Seleziona Cliente'),
                      ditta:  Yup.string().required('Seleziona Ditta'),
                    });


export const validationSchemaRicavi = Yup.object().shape({
  ricavi: Yup.number()
    .typeError('Ricavi must be a number')
    .required('Ricavi is required'),

});



export async function jasperMonitorProgettiBlob( fromDate: Date, toDate: Date, ditta: String, codcli: String, formato: String) {
  try {
    const username = 'jasperadmin';
    const password = 'Tibco2024@';
    const base64encodedData = Buffer.from(`${username}:${password}`).toString('base64');

    const fromDateString = fromDate ? format(fromDate, 'yyyy-MM-dd') : '';
    const toDateString = toDate ? format(toDate, 'yyyy-MM-dd') : '';

         let pag = '';
             if (formato === 'xlsx') {
                pag = 'ignorePagination=true&'
            }

    // check codcli = 0 for admin

      const mycodcli = codcli === '0' ? '' : codcli;


    const response = await fetch(`${BASE_URL_JASPERSERVER}/rest_v2/reports/reports/repcliversore${formato}.${formato}?${pag}datainizio=${fromDateString}&datafine=${toDateString}&codcli=${mycodcli}&ditta=${ditta}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/'+formato,
        'Authorization': `Basic ${base64encodedData}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch the report');
    }

    const blob = await response.blob();
    return blob;
  } catch (error) {
    console.error('Error generating report:', error);
    throw error; // Rethrow the error to handle it in the calling code if needed
  }
};




